/** Module links now live in the shared workspace header on every mail route. */
export function MailNavigation() {
  return null;
}
